type Cat4784SkipPlacementContext = {
  isTreatment: boolean
  isSkipButtonVisible: boolean
  isPremium: boolean
  isOldAge: boolean
  isMobile: boolean
  isDacError: boolean
}

export const shouldRenderCat4784SkipBelowBack = ({
  isTreatment,
  isSkipButtonVisible,
  isPremium,
  isOldAge,
  isMobile,
  isDacError
}: Cat4784SkipPlacementContext): boolean =>
  isTreatment &&
  isSkipButtonVisible &&
  ((!isPremium && !isOldAge && (isMobile || !isDacError)) ||
    (!isPremium && isOldAge) ||
    (isPremium && isMobile))
